// **********************************************************************
// ******** reset da senha do prestador ou do cliente ***
// ******** app/ResetSenha/resetsenha.jsx
// ******** autor: WdePaula / Microvolution
// ******** v1.0 data: 31/05/24 | 19h37
// ******** 
// ********  reset da senha do prestador ou do cliente ***
// **********************************************************************





import React, { useState } from "react";
import { encryptPass } from "../../Services/cryptosenha";
import { Link, useNavigate } from 'react-router-dom';
import { Oval } from 'react-loader-spinner';  // Import the loading spinner

import "./resetsenha.css";

const API_URL = process.env.REACT_APP_API_URL;
const BA_USERNAME = process.env.REACT_APP_BA_USERNAME;
// Use a senha ORIGINAL (sem criptografia) para Basic Auth:
// const BA_PASSWORD = process.env.REACT_APP_BA_PASSWORD; // SENHA ORIGINAL
// // const BA_PASSWORD = encryptPass(process.env.REACT_APP_BA_PASSWORD); // substituída a linha acima por esta 22/7/24w

function ResetPassword() {
    var ano = new Date().getFullYear();

    const [emailreset, setEmailreset] = useState('');
    const [mensagem, setMensagem] = useState('');
    // const [sucesso, setSucesso] = useState(false);
    const [tipoApp, setTipoApp] = useState(1); // marcado como prestador default
    const [colaborador, setColaborador] = useState(0); // marcado como prestador default
    const navigate = useNavigate(); 
    const [loading, setLoading] = useState(false); // loading na tela

    async function ResetSenha() {
        if (!emailreset) {
            setMensagem('Email não pode ficar em branco.');
            // setSucesso(false);

            setTimeout(() => {
                setMensagem('');
            }, 7000);
            return;
        }

        // const authString = btoa(`${BA_USERNAME}:${BA_PASSWORD}`);
        // console.log ('colaborador :', colaborador);
        const authString = btoa(`${BA_USERNAME}:${encryptPass(process.env.REACT_APP_BA_PASSWORD)}`);

        let url;
        if (colaborador === 1) {
            url = new URL(`${API_URL}/usuario/ColaboradorContaExistente`);
        } else {
            url = new URL(`${API_URL}/usuario/ContaExistente`);
        }

        // const url = new URL(`${API_URL}/usuario/ContaExistente`);
        // console.log('Auth String:', authString);
        // console.log('Full URL:', url);

        // // Adicione este debug antes da requisição:
        // console.log('Username:', BA_USERNAME);
        // console.log('Password (raw):', process.env.REACT_APP_BA_PASSWORD);
        // console.log('Password (criptografado):', encryptPass(process.env.REACT_APP_BA_PASSWORD));
        // console.log('Auth String:', authString);
        // console.log('Expected Format: username:password');

        url.search = new URLSearchParams({
            email: emailreset,
            tipoApp: parseInt(tipoApp, 10) // Ensure tipoApp is sent as an Integer
        }).toString();

        setLoading(true);

        try {
            const response = await fetch(url.toString(), {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Basic ${authString}`
                }
            });
            if (!response.ok) {
                const data = await response.json();
                throw new Error(data.retorno);
            }

            // setSucesso(true);

            const data = await response.json();
            const userName = data.nome; // Assume the response contains the user's name

            const validationCode = generateValidationCode();
            const validationUrl = new URL(`${API_URL}/usuario/validaEmail`);
            validationUrl.search = new URLSearchParams({
                nome: userName,
                email: emailreset,
                codigo: validationCode
            }).toString();

            const validationResponse = await fetch(validationUrl.toString(), {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Basic ${authString}`
                }
            });

           
            if (!validationResponse.ok) {
                const validationData = await validationResponse.json();
                throw new Error(validationData.retorno);
            }
            // Save the code in a state or send it to the email
            // console.log("Validation Code: ", validationCode);

            // After successful email check, navigate to the next screen
            // navigate('/app/resetsenha/cv', { state: { email: emailreset, validationCode: validationCode } }); // modificado pela linha abaixo
            navigate('/app/resetsenha/cv', { state: { email: emailreset, validationCode: validationCode, colaborador: colaborador } });
        } catch (error) {
            // Trate o erro
            console.error('Fetch error:', error);
            if (error.message.includes('CORS policy')) {
                setMensagem('Erro de CORS. Verifique as configurações do servidor.');            
            } else if (error.message === 'Failed to fetch') {
                setMensagem('Erro de conexão. Verifique sua conexão com a internet e tente novamente.');            
            } else {
                setMensagem(error.message);
            }

            setTimeout(() => {
                setMensagem('');
            }, 7000);
        } finally {
            setLoading(false);
        }
    }
    // async function ResetSenha() {
    //     if (!emailreset) {
    //         setMensagem('Email não pode ficar em branco.');
    //         setTimeout(() => setMensagem(''), 7000);
    //         return;
    //     }

    //     // VERIFIQUE - não está usando as variáveis do .env corretamente
    //     console.log('BA_USERNAME from env:', process.env.REACT_APP_BA_USERNAME);
    //     console.log('BA_PASSWORD from env:', process.env.REACT_APP_BA_PASSWORD);
    //     console.log('BA_PASSWORD from env criptografado:', encryptPass(process.env.REACT_APP_BA_PASSWORD));

    //     // Use as variáveis do .env CORRETAMENTE:
    //     const authString = btoa(`${process.env.REACT_APP_BA_USERNAME}:${encryptPass(process.env.REACT_APP_BA_PASSWORD)}`);
    //     // const authString = btoa(`${process.env.REACT_APP_BA_USERNAME}:${process.env.REACT_APP_BA_PASSWORD}`);
        
    //     console.log('Correct Auth String:', authString); // Deve ser diferente de "d214OmNiaW5mbyMxMzg2MDAjb21lZ2E="

    //     const url = `${API_URL}/usuario/ContaExistente?email=${encodeURIComponent(emailreset)}&tipoApp=${tipoApp}`;

    //     setLoading(true);

    //     try {
    //         const response = await fetch(url, {
    //             method: 'GET',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 'Authorization': `Basic ${authString}`
    //             }
    //         });

    //         // Primeiro leia como texto
    //         const responseText = await response.text();
    //         console.log('Response status:', response.status);
    //         console.log('Response text:', responseText);

    //         if (!response.ok) {
    //             // Tente parsear como JSON
    //             try {
    //                 const errorData = JSON.parse(responseText);
    //                 throw new Error(errorData.retorno || `Erro ${response.status}`);
    //             } catch {
    //                 throw new Error(responseText || `Erro HTTP: ${response.status}`);
    //             }
    //         }

    //         // Parse a resposta bem-sucedida
    //         const data = JSON.parse(responseText);
    //         console.log('Success data:', data);

    //         // Continue com o processo...
    //         if (data.retorno === 'OK') {
    //             const userName = data.nome;
    //             const validationCode = generateValidationCode();
                
    //             navigate('/app/resetsenha/cv', { 
    //                 state: { email: emailreset, validationCode: validationCode } 
    //             });
    //         } else {
    //             throw new Error(data.retorno || 'Erro ao verificar conta');
    //         }

    //     } catch (error) {
    //         console.error('Error:', error);
    //         setMensagem(error.message);
    //         setTimeout(() => setMensagem(''), 7000);
    //     } finally {
    //         setLoading(false);
    //     }
    // }

    function ChangeMail(element) {
        setEmailreset(element.target.value);
    }

    function generateValidationCode() {
        return Math.floor(100000 + Math.random() * 900000).toString();
    }

    // function ChangeTipoAppCliente(element) {
    //     setTipoApp(0);
    // }

    // function ChangeTipoAppPrestador(element) {
    //     setTipoApp(1);
    // }

    // function ChangeTipoApp(value) {
    //     setTipoApp(value);
    // }    

    return (
        <section id="novaconta">
            <div className="container login-container">
                <div className="row">
                    <h3>Esqueceu a Senha?</h3>
                    <div className="col-md-12 login-form-2">
                        <h3>Recuperar Senha</h3>

                        {loading && (
                            <div className="loading-spinner-container">
                                <Oval color="#00BFFF" height={80} width={80} />
                            </div>
                        )}
                        <div className={`row ${loading ? 'd-none' : ''}`}></div>

                        <div className="form-check">
                            <input 
                                // onChange={ChangeTipoApp} 
                                onChange={() => setTipoApp(0)} 
                                className="form-check-input" 
                                type="radio" 
                                name="flexRadioDefault" 
                                id="flexRadioDefault1"
                                checked={tipoApp === 0}
                            />
                            <label className="form-check-label" htmlFor="flexRadioDefault1">
                                Sou Cliente
                            </label>
                        </div>
                        <div className="form-check">
                            <input 
                                // onChange={ChangeTipoApp} 
                                onChange={() => setTipoApp(1)} 
                                className="form-check-input" 
                                type="radio" 
                                name="flexRadioDefault" 
                                id="flexRadioDefault2" 
                                defaultChecked
                                checked={tipoApp === 1}
                            />
                            <label className="form-check-label" htmlFor="flexRadioDefault2">
                                Sou Prestador de Serviços
                            </label>
                        </div>
                        <div className="form-check">
                            <input 
                                // onChange={ChangeTipoApp} 
                                onChange={() => setColaborador(1)} 
                                className="form-check-input" 
                                type="radio" 
                                name="flexRadioDefault" 
                                id="flexRadioDefault3" 
                                defaultChecked
                                checked={colaborador === 1}
                            />
                            <label className="form-check-label" htmlFor="flexRadioDefault3">
                                Sou Colaborador
                            </label>
                        </div>
                        <br />
                        <div className="form-group mb-3">
                            <input 
                                onChange={ChangeMail} 
                                type="email" 
                                className="form-control" 
                                id="emailusuario" 
                                name="emailusuario" 
                                placeholder="Digite seu Email cadastrado no Agendex (Cliente ou Prestador) *" 
                            />
                        </div>
                        <div className="form-group">
                            <input 
                                type="button" 
                                onClick={ResetSenha} 
                                className="btnSubmit" 
                                value="Enviar ►" 
                            />
                            {mensagem.length > 0 && <div className="alert alert-danger mt-2" role="alert">{mensagem}</div>}
                        </div>
                    </div>
                </div>
                <p className="text-sm-end">(*) campo obrigatório.</p>
                <div className="textoRodape">
                    <Link to="/app/login">Já tenho conta. Toque para fazer login.</Link>
                    <br />
                    <Link to="/app/novaconta">Não tenho conta. Toque para criar uma agora.</Link>
                    <br /><br />
                    <p> Desenvolvido por MVinfo Sistemas | WMX Group 2021 - {ano}</p>
                </div>
            </div>
        </section>
    );
}

export default ResetPassword;